var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex justify-center items-center px-3 font-medium text-sm leading-none uppercase text-navy-100 text-opacity-50"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }